import React from "react";

const ModalContainer = () => {
  return (
    <div id="modal-container"></div>
  );
};

export default ModalContainer;